import { processResponse } from 'Fetch';

export const MENTION_ME_PARTNER_CODE = 'mm191789f5';
export const MENTION_ME_API_VERSION = 'v2';
export const MENTION_ME_LOCALE_CODE = 'en_GB';
export const MENTION_ME_ENROL_URL = `https://mention-me.com/api/consumer/${MENTION_ME_API_VERSION}/referrer/enrol`;

export type MentionMeCustomer = {
  emailAddress: string;
  firstname?: string;
  surname?: string;
  uniqueIdentifier?: string;
};

export type MentionMeOrder = {
  currencyCode?: string;
  orderNumber?: string;
  total?: string;
};

export type MentionMeRequest = {
  appName?: string;
  localeCode?: string;
  partnerCode: string;
  situation: string;
};

export type MentionMeEnrolPayload = {
  customer: MentionMeCustomer;
  order?: MentionMeOrder;
  request: MentionMeRequest;
};

export type MentionMeShareLink = {
  defaultShareMessage?: string;
  protocol?: string;
  type?: string;
  url: string;
};

export type MentionMeEnrolResponse = {
  nameShare?: {
    name?: string;
    referralCode?: string;
  };
  offer?: {
    description?: string;
    headline?: string;
  };
  shareLinks?: MentionMeShareLink[];
  termsLinks?: {
    linkToTermsInLocale?: string;
    localeCode?: string;
  };
};

export const enrolReferrer = async (
  payload: MentionMeEnrolPayload,
  abortController?: AbortController,
): Promise<MentionMeEnrolResponse> => fetch(MENTION_ME_ENROL_URL, {
  body: JSON.stringify(payload),
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
  },
  method: 'POST',
  signal: abortController?.signal,
}).then(processResponse);
